const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Footer/FooterGap.tsx';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { css, cx } from '@emotion/css';

interface Props {}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => css`
            flex: 1 1 auto;
            min-width: 0;
        `,
        [theme]
    );
}

export const FooterGap = (props: Props) => {
    const className = useCSSClasses();
    return <div className={cx('FooterGap', className)} />;
};
